<template>
  <div v-if="issue && issue.id && extraFields && extraFields.length" class="extrafield-container row">
    <div class="col-12 ef-header">
      <h4> {{ $t('common.extra_fields') }}</h4>
      <div v-if="issue.active" class="custom-control-vuvle custom-control custom-switch">
        <input id="editEFMode" v-model="editMode" type="checkbox" class="custom-control-input" @click="toggleEdit">
        <label class="custom-control-label" for="editEFMode">{{ $t('action.edit') }}</label>
      </div>
    </div>

    <div class="container-fluid">
      <div v-for="(extraField, index) in extraFields" :key="index" data-toggle="tooltip" data-placement="top" :title="extraField.description" class="row ef-row">
        <div v-if="!editMode || (!superUser && extraField.writePermissions !== 'EMPLOYEES')" class="ef-label">
          {{extraField.name}}
        </div>

        <div v-if="editMode && extraField.type !== 'MULTIVALUE' && (superUser || extraField.writePermissions === 'EMPLOYEES')" class="col-12 input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text">{{extraField.name}}</span>
          </div>
          <textarea v-if="extraField.type === 'TEXTAREA'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" class="form-control" :class="issueValues.class && issueValues.class[extraField.id]" />
          <input v-else-if="extraField.type === 'STRING'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" type="text" class="form-control" :class="issueValues.class && issueValues.class[extraField.id]">
          <input v-else-if="extraField.type === 'NUMBER'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" type="number" class="form-control" :class="issueValues.class && issueValues.class[extraField.id]">
          <select v-else-if="extraField.type === 'SELECT'" v-model="issueValues[extraField.id]" class="form-control form-select" :class="issueValues.class && issueValues.class[extraField.id]">
            <option v-for="(option, index1) in extraField.extraFieldOptions" :key="index1" :value="option.value">
              {{ option.name }}
            </option>
          </select>
          <div v-else-if="extraField.type === 'BOOLEAN'" class="form-control">
            <input v-model="issueValues[extraField.id]" type="checkbox">
            <span v-if="issueValues.class && issueValues.class[extraField.id]==='is-valid'" class="ml-2" style="font-size:13px;color:green;">Su cambio fué guardado</span>
            <span v-else-if="issueValues.class && issueValues.class[extraField.id]==='is-invalid'" class="ml-2" style="font-size:13px;color:red;">Sin Permisos</span>
            <span class="d-none d-md-inline" style="font-size:14px;float:right;"> ← {{ $t('message.bool_warning') }}</span>
          </div>

          <div v-if="extraField.type !== 'BOOLEAN' && issueValues.class && issueValues.class[extraField.id]==='is-invalid'" style="position:absolute;right:25%;bottom:25%;">
            <span class="ml-2" style="font-size:13px;color:red;">{{ $t('message.no_permissions') }}</span>
          </div>

          <div class="input-group-append">
            <button class="btn btn-outline-success" type="button" @click="saveEFV(extraField)">
              {{ $t('action.save') }}
            </button>
          </div>
        </div>
        <div v-else-if="editMode && extraField.type === 'MULTIVALUE' && (superUser || extraField.writePermissions === 'EMPLOYEES')" class="col-12 mb-2 mt-2 ef-multivalue-edit">
          <div class="list-group-item list-group-item-action justify-content-between align-items-center active">
            {{extraField.name}}
          </div>
          <a v-for="(value, index1) in issueValues[extraField.id]" :key="index1" class="list-group-item list-group-item-action">
            <b>{{ formatDate(value.dateSetted) }}</b> - {{value.value}}
          </a>

          <div class="list-group-item list-group-item-action">
            <div class="input-group">
              <div class="input-group-prepend">
                <button class="btn btn-outline-success" type="button" @click="addValue(extraField)">
                  +
                </button>
              </div>
              <input v-model="newValue[extraField.id]" type="text" :placeholder="'Ingrese nuevo ' + extraField.name" class="form-control">
            </div>
          </div>
        </div>
        <div v-else-if="extraField.type === 'BOOLEAN'" class="ef-value ef-bool">
          <span v-if="issueValues[extraField.id]" class="ef-badge ef-badge-yes">Sí</span>
          <span v-else class="ef-badge ef-badge-no">No</span>
        </div>
        <div v-else-if="extraField.type === 'MULTIVALUE'" class="ef-value ef-multivalue">
          <template v-if="issueValues[extraField.id] && issueValues[extraField.id].length">
            <div v-for="(value, index1) in issueValues[extraField.id]" :key="index1" class="ef-multivalue-item">
              <b>{{ formatDate(value.dateSetted, true) }}</b> - Dijo {{value.username}}: "<i>{{ value.value }}</i>"
            </div>
          </template>
          <span v-else class="ef-empty">Sin registros.</span>
        </div>
        <div v-else class="ef-value">
          {{ issueValues[extraField.id] || '—' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExtraFieldService from '@/services/extrafield.service';
import { formatDate } from '@/utils/page-utils';

export default {
    name: 'IssueExtraField',
    props: {
        issue: Object,
        superUser: Boolean
    },
    data() {
        return {
            extraFields: [],
            issueValues: {
                class: {}
            },
            newValue: {},
            editMode: false
        };
    },
    created() {
        this.issueProcessing = this.issue;
        this.initEFComponent();
    },
    updated() {
        // avoid looping
        if (!this.issueProcessing || this.issueProcessing.id !== this.issue.id) {
            this.issueProcessing = this.issue;
            this.initEFComponent();
        }
    },
    methods: {
        initEFComponent() {
            this.editMode = false;
            // reset issue values.
            this.issueValues = {
                class: {}
            };
            // MAYBE, just MAYBE todo, extraFields could be implemented in the IssuesList, then trailed here
            this.getExtraFields();
            // getExtraFields is getting the issueValues also, I would recommend to split those, like before.
            // this.getIssueValues();
        },
        formatDate,
        toggleEdit() {
            this.editMode = !this.editMode;
        },
        getExtraFields() {
            const self = this;
            ExtraFieldService.getExtraFields(true).then(
                response => {
                    ExtraFieldService.getIssueExtraFieldVals(this.issue.id).then(
                        response1 => {
                            self.extraFields = response.data;
                            response1.data.forEach(function eachExtraFieldValue(efv) {
                                if (efv.extrafield.type === 'MULTIVALUE') {
                                    self.issueValues[efv.extrafield.id] = efv.values;
                                } else if (efv.extrafield.type === 'BOOLEAN') {
                                    self.issueValues[efv.extrafield.id] = efv.value === 'true';
                                } else {
                                    // customization for smartdrone
                                    if (efv.extrafield.name === 'Accesorios') {
                                        self.issue.accesorios = 'Accesorios: ' + efv.value;
                                    }
                                    self.issueValues[efv.extrafield.id] = efv.value;
                                }
                            });
                        },
                        error1 => {
                            console.log(error1.response && error1.response.data ||
                      error1.message || error1.toString());
                        }
                    );
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        addValue(extraField) {
            var self = this;
            var data = {
                value: this.newValue[extraField.id]
            };
            if (data.value.length) {
                ExtraFieldService.addValueToMultival(extraField.id, this.issue.id, data).then(
                    response => {
                        self.newValue[extraField.id] = '';
                        self.getExtraFields();
                    },
                    error => {
                        if (error.response.status === 403) {
                            self.newValue[extraField.id] = 'No tienes permiso para agregar.';
                            self.getExtraFields();
                        }
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );
            }
        },
        saveExtraFields() {
            var self = this;
            this.extraFields.forEach(function eachExtraField(efv) {
                if (efv.type !== 'MULTIVALUE') {
                    self.saveEFV(efv);
                }
            });
        },
        // removeValue() {
        //     alert('no está implementado');
        // },
        saveEFV(extraField) {
            var data = {
                extrafield: extraField,
                value: this.issueValues[extraField.id]
            };
            var self = this;

            self.issueValues.class = {};
            ExtraFieldService.saveExtraFieldValue(this.issue.id, data).then(
                response => {
                    self.getExtraFields();
                    self.issueValues.class[extraField.id] = 'is-valid';
                },
                error => {
                    if (error.response.status === 403) {
                        self.getExtraFields();
                        self.issueValues.class[extraField.id] = 'is-invalid';
                    }
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        }
    /* eslint-disable no-console */
    }
};
</script>
<style lang="scss">
@import "../../../styles/theme.scss";

.remove-info {
    right: 15px;
    position: absolute;
    font-size: 15px;
}

.custom-control-vuvle {
    line-height: 1.4;
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transform-origin: right center;

    .custom-control-label {
        font-size: 13px;
        font-weight: 600;
        color: $issue-text-muted;
    }
}

.extrafield-container {
    padding-top: 18px;

    .ef-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 10px;

        h4 {
            margin: 0;
            font-size: 13px;
            font-weight: 700;
            color: $issue-text;
            text-transform: uppercase;
            letter-spacing: 0.03em;
        }
    }

    .ef-row {
        align-items: center;
        padding: 9px 0;
        border-bottom: 1px solid $issue-border;
        &:last-child {
            border-bottom: none;
        }
    }

    .ef-label {
        flex: 0 0 170px;
        max-width: 170px;
        padding-right: 12px;
        font-size: 12px;
        font-weight: 600;
        color: $issue-text-muted;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    .ef-value {
        flex: 1 1 0;
        min-width: 0;
        padding: 7px 12px;
        font-size: 13.5px;
        color: $issue-text;
        background-color: $issue-bg-subtle;
        border: 1px solid $issue-border;
        border-radius: $issue-radius-sm;
    }

    .ef-empty {
        color: $issue-text-muted;
        font-style: italic;
    }

    .ef-bool {
        background-color: transparent;
        border: none;
        padding: 0;
    }

    .ef-badge {
        display: inline-block;
        padding: 3px 12px;
        border-radius: 999px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }
    .ef-badge-yes {
        color: darken($issue-success, 8%);
        background-color: $issue-success-soft;
    }
    .ef-badge-no {
        color: $issue-text-muted;
        background-color: $issue-secondary-soft;
    }

    .ef-multivalue {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .ef-multivalue-item {
        font-size: 13px;
        line-height: 1.5;
        + .ef-multivalue-item {
            padding-top: 6px;
            border-top: 1px dashed $issue-border;
        }
    }

    .ef-multivalue-edit {
        .list-group-item {
            border-color: $issue-border;
            font-size: 13px;
            &.active {
                background-color: $issue-primary;
                border-color: $issue-primary;
            }
        }
    }

    @media(max-width: 600px) {
        .ef-row {
            flex-direction: column;
            align-items: stretch;
        }
        .ef-label {
            flex-basis: auto;
            max-width: none;
            margin-bottom: 4px;
        }
        .input-group.mb-1 {
            margin-bottom: 10px!important;
            .input-group-prepend {
                width: 100%;
                .input-group-text {
                    width: 100%;
                }
            }
        }
    }
}
</style>
